import React from "react";
import { Box, Link, Stack, Typography } from "@mui/material";
import Footer from "../components/Footer";
import { motion } from "framer-motion";
import MenuBar from "../components/MenuBar";
import Head from "next/head";
import Navbar from "../components/Navbar";
import StickyWhatsapp from "../components/StickyWhatsapp";

const textAni = {
  offscreen: { y: 20, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
    // transition: {  duration: 1 },
  },
};
const Terms = () => {
  const terms = [
    {
      title: "1. INTRODUCTION",
      content: [
        `Techbrain Networks, India is a leading software product development company that specializes in AI, IoT, Big data, Blockchain, cloud computing, Quantum computing and Digital Marketing.`,
      ],
    },
    {
      title: `2. USE OF THE WEBSITE`,
      content: [
        `a) You may use this website for informational purposes only. You may not copy, reproduce, distribute, transmit, display, perform, or create derivative works from any content on this website without our prior written consent.`,
        `b) You may not use this website for any illegal or unauthorized purpose. You may not use any automated system, such as robots or spiders, to access this website.`,
        `c) You are responsible for ensuring that your use of this website is in compliance with all applicable laws and regulations.`,
        `d) We reserve the right to modify, suspend, or discontinue this website at any time, with or without notice.`,
      ],
    },
    {
      title: `3. INTELLECTUAL PROPERTY`,
      content: [
        `a) All content on this website, including but not limited to text, graphics, logos, images, audio clips, and video clips, is the property of Techbrain Networks, India or its content suppliers and is protected by copyright, trademark, and other intellectual property laws.`,
        `b) You may not use any content on this website for any commercial purpose without our prior written consent.`,
        `c) You may not use any trademarks, logos, or service marks on this website without our prior written consent.`,
        `d) You may not modify, copy, reproduce, distribute, transmit, display, perform, or create derivative works from any content on this website without our prior written consent.`,
      ],
    },
    {
      title: `4. DISCLAIMER OF WARRANTIES`,
      content: [
        `a) Techbrain Networks, India makes no representations or warranties of any kind, express or implied, regarding this website or its content. We expressly disclaim all warranties, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement.`,
        `b) We do not warrant that this website will be uninterrupted or error-free, or that defects will be corrected.`,
        `c) We do not warrant or make any representations regarding the use or the results of the use of the content on this website in terms of its correctness, accuracy, reliability, or otherwise.`,
      ],
    },
    {
      title: `5. LIMITATION OF LIABILITY`,
      content: [
        `a) Techbrain Networks, India shall not be liable for any damages whatsoever, including but not limited to direct, indirect, incidental, consequential, or punitive damages arising out of the use of or inability to use this website or its content, even if we have been advised of the possibility of such damages.`,
        `b) If you are dissatisfied with any portion of this website or its content, your sole and exclusive remedy is to discontinue using this website.`,
      ],
    },
    {
      title: `6. LINKS TO THIRD-PARTY WEBSITES`,
      content: [
        `a) This website may contain links to third-party websites that are not owned or controlled by Techbrain Networks, India. We are not responsible for the content, privacy policies, or practices of any third-party websites.`,
        `b) We do not endorse or make any representations about any third-party websites or their content.`,
        `c) You acknowledge and agree that Techbrain Networks, India shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any third-party content, goods, or services available on or through any third-party websites.`,
      ],
    },
    {
      title: `7. PRIVACY POLICY`,
      content: [
        `a) We are committed to protecting your privacy. Our Privacy Policy explains how we collect, use and disclose information about you when you use our website. By using our website, you consent to our Privacy Policy.`,
        `b) Our Privacy Policy is incorporated into these terms and conditions and can be accessed on our website.`,
      ],
    },
    {
      title: `8. INDEMNIFICATION`,
      content: [
        `You agree to indemnify, defend, and hold harmless Techbrain Networks, India, its officers, directors, employees, agents, and affiliates from and against any and all claims, damages, liabilities, costs, and expenses, including but not limited to reasonable attorneys' fees, arising out of or in connection with your use of this website or your breach of these terms and conditions.`,
      ],
    },
    {
      title: `9. GOVERNING LAW AND JURISDICTION`,
      content: [
        `a) You accept that any claims arising against Techbrain Networks, India shall be subject to the exclusive jurisdiction of the High Court at Chennai and the laws of India shall apply therein.`,
        `b) You agree that any action at law or in equity arising out of or relating to these terms and conditions or this website shall be filed only in the High Court at Chennai located in the State of Tamil Nadu, and you hereby consent and submit to the personal jurisdiction of such courts for the purposes of litigating any such action.`,
      ],
    },
    {
      title: `10. ENTIRE AGREEMENT`,
      content: [
        `These terms and conditions constitute the entire agreement between you and Techbrain Networks, India regarding the use of this website and supersede all prior or contemporaneous communications and proposals, whether oral or written, between you and Techbrain Networks, India.`,
      ],
    },
    {
      title: `11. SEVERABILITY`,
      content: [
        `If any provision of these terms and conditions is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect.`,
      ],
    },
    {
      title: `12. WAIVER`,
      content: [
        `The failure of Techbrain Networks, India to enforce any right or provision of these terms and conditions shall not be deemed a waiver of such right or provision.`,
      ],
    },
    {
      title: `13. ASSIGNMENT`,
      content: [
        `You may not assign these terms and conditions or any rights or obligations hereunder, whether by operation of law or otherwise, without our prior written consent.`,
      ],
    },
    {
      title: `14. CONTACT US`,
      content: [
        `If you have any questions about these terms and conditions or our website, please contact us at `,
      ],
    },
    {
      title: `15. ACKNOWLEDGEMENT`,
      content: [
        `By using our website, you acknowledge that you have read, understood, and agreed to these terms and conditions and that these terms and conditions constitute a binding agreement between you and Techbrain Networks, India.`,
      ],
    },
  ];
  return (
    <>
      <Head>
     
        <title>Terms and Conditions - Techbrain Networks</title>
        <meta name="description" content="Read the terms and conditions governing the use of Techbrain Networks products and services. Stay informed about our policies and agreements." />
        <meta name="keywords" content="Techbrain Networks, Terms and Conditions, Policies, Agreements, Legal, User Agreements, Terms of Service, Company Policies" />
        <meta name="robots" content="index, follow" />
       
        <meta property="og:title" content="Terms and Conditions - Techbrain Networks" />
        <meta property="og:description" content="Explore the terms and conditions of Techbrain Networks to understand our policies and user agreements for various services." />
        <meta property="og:url" content="https://www.techbrainnetworks.com/terms-and-conditions" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
       
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms and Conditions - Techbrain Networks" />
        <meta name="twitter:description" content="Review the terms and conditions of Techbrain Networks to know more about our policies and user agreements." />
        <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
        <link rel="canonical" href="https://www.techbrainnetworks.com/terms-and-conditions" />
        <link rel="icon" href="/favicon.png" />

        <meta name="author" content="Techbrain Networks" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta property="og:updated_time" content={new Date().toISOString()} />
        </Head>
        
      <Navbar color="#fff"  />
      <StickyWhatsapp link={"https://api.whatsapp.com/send?phone=918754906714"} />
      {/* section 1 */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: ["17rem", "25rem", "25rem", "29rem", "43rem"],
          gap: { xs: 2, sm: 3 },
          bgcolor: "#080f25",
          px: { xs: 2, sm: 0 },
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* plus */}
        <Stack
          component={motion.div}
          animate={{ y: 20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            left: ["5%"],
            top: ["22%"],
          }}
        >
          <motion.img
            alt="icon"
            animate={{ rotate: 360 }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "linear",
            }}
            src="/plus-p.png"
            style={{ height: "100%" }}
          />
        </Stack>
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: -20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "2rem", "2rem"],
            position: "absolute",
            bottom: ["9%"],
          }}
        >
          <img alt="icon" src="/star3d-b.png" style={{ height: "100%" }} />
        </Stack>
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: 20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "2rem", "2rem"],
            position: "absolute",
            right: ["8%"],
            bottom: ["13%"],
          }}
        >
          <img alt="icon" src="/spark-g.png" style={{ height: "100%" }} />
        </Stack>
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: 20 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            height: ["1rem", "1rem", "1.5rem", "2rem", "2rem"],
            position: "absolute",
            left: ["43%"],
            top: ["10%"],
          }}
        >
          <img alt="icon" src="/star3d.png" style={{ height: "100%" }} />
        </Stack>
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".5rem", xl: "1rem" },
            height: { xs: ".5rem", xl: "1rem" },
            position: "absolute",
            right: ["31%"],
            borderRadius: "100%",
            bgcolor: "#1BDE9C",
            bottom: ["10%"],
          }}
        />
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".7rem", xl: "1rem" },
            height: { xs: ".7rem", xl: "1rem" },
            position: "absolute",
            left: ["29%"],
            borderRadius: "100%",
            bgcolor: "#f2c444",
            bottom: ["9%"],
          }}
        />
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".7rem", xl: "1rem" },
            height: { xs: ".7rem", xl: "1rem" },
            position: "absolute",
            right: ["20%"],
            borderRadius: "100%",
            bgcolor: "#ad00ff",
            top: ["29%"],
          }}
        />
        <Stack
          sx={{
            display: ["none", "block"],
            width: { xs: ".5rem", xl: "1rem" },
            height: { xs: ".5rem", xl: "1rem" },
            position: "absolute",
            right: ["22%"],
            borderRadius: "100%",
            bgcolor: "#38b7ff",
            top: ["31%"],
          }}
        />
        {/* star 360 */}
        <Stack
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            width: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            left: ["5%"],
            top: ["70%"],
          }}
        >
          <img alt="icon" src="/star4.png" style={{ width: "100%" }} />
        </Stack>
        {/* sqr 360 */}
        <Stack
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{
            duration: 7,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            width: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            right: ["5%"],
            top: ["25%"],
          }}
        >
          <img alt="icon" src="/square.png" style={{ width: "100%" }} />
        </Stack>
        <Typography
          width={{ xs: "100%", sm: "70%", md: "80%", lg: "85%", xl: "75%" }}
          variants={textAni}
          className="worksans"
          viewport={{ once: true, amount: 0.5 }}
          initial={"offscreen"}
          whileInView={"onscreen"}
          component={motion.h1}
          transition={{ delay: 0.5 }}
          sx={{
            fontSize: ["35px", "50px", "60px", "75px", "90px"],
            textAlign: "center",
            background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
            backgroundClip: "text",
           textFillColor: "transparent",
            lineHeight: ["35px", "55px", "65px", "105px"],
            fontWeight: [800],
            mb: { xs: 1 },
          }}
        >
          Terms and Conditions
        </Typography>
      </Box>

      <Stack
        direction="column"
        alignItems="center"
        width="100%"
        px={{ xs: 2, sm: 4, md: 5, lg: 10, xl: 12 }}
        sx={{
          //   px: [2, 4, 7, 10, 15],
          py: [5, 7, 8, 10, 15],
        }}
        gap={{ xs: 2 }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: [".85rem", ".9rem", ".8rem", "1.15rem", "1.3rem"],
            //   lineHeight: "normal",
            textAlign: "justify",
            color:'#fff',
          }}
        >
          We are pleased to welcome you to Techbrain Networks, India. By accessing or using our website, you acknowledge that you
          have read, understood, and agreed to the following terms and
          conditions.
        </Typography>
        <Stack
          direction="column"
          gap={{ xs: 0.7, sm: 1, md: 3 }}
          sx={{
            fontSize: [".7rem", ".9rem", ".8rem", "1.15rem"],
            lineHeight: "normal",
          }}
        >
          {terms.map((i, k) => (
            <Stack
              direction="column"
              alignItems={{ xs: "flex-start" }}
              key={k}
              gap={{ xs: 0.5, sm: 1, md: 1 }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: [".85rem", ".9rem", ".8rem", "1.15rem", "1.3rem"],
                  //   lineHeight: "normal",
                  textAlign: "left",
                  fontWeight: "600",
                  background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
                  backgroundClip: "text",
                 textFillColor: "transparent",
                  mb: [0.3, 0.5, 1, 1, 1],
                }}
              >
                {i.title}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontSize: [".85rem", ".9rem", ".8rem", "1.15rem", "1.3rem"],
                  //   lineHeight: "normal",
                  textAlign: "justify",
                  color:'#fff',
                }}
              >
                {i.content.map((i, index) => (
                  <React.Fragment key={index}>
                    {i}
                    {
                      k === 13 ?
                        <>{" "}
                          <Link
                            color={"inherit"}
                            underline="hover"
                            href="mailto:contact@techbrainnetworks.com"
                          >
                            contact@techbrainnetworks.com
                          </Link>
                        </>
                        : null
                    }
                    <br /> <br />
                  </React.Fragment>
                ))}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
      <Footer />
    </>
  );
};

export default Terms;
